import { render, staticRenderFns } from "./NotificationTimeSinceCleared.vue?vue&type=template&id=d054635e"
import script from "./NotificationTimeSinceCleared.vue?vue&type=script&lang=js"
export * from "./NotificationTimeSinceCleared.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports